import React, { Component } from "react";
import raj from './raj.jpeg';
import MenuItem from "../menu-item/Menu-ItemComponent";

import './directorymenu.scss';

// this will be class Comp bc we will store STATE of all menu Comp

class Directory extends Component {
    constructor() {
        super();
        this.state = {
            sections: [{
                title: 'hats',
                imageUrl: 'https://i.ibb.co/cvpntL1/hats.png',
                id: 1,
                linkUrl: 'shop/hats'
            },
            {
                title: 'jackets',
                imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                id: 2,
                linkUrl: 'shop/jackets'
            },
            {
                title: 'sneakers',
                imageUrl: 'https://i.ibb.co/0jqHpnp/sneakers.png',
                id: 3,
                linkUrl: 'shop/sneakers'
            },
            {
                title: 'womens',
                imageUrl: 'https://i.ibb.co/GCCdy8t/womens.png',
                size: 'large',
                id: 4,
                linkUrl: 'shop/womens'
            },
            {
                title: 'mens',
                imageUrl: raj,
                // imageUrl: 'https://i.ibb.co/R70vBrQ/men.png
                size: 'large',
                id: 5,
                linkUrl: 'shop/mens'
            }]
        }
    }
    render() {
    
 
        return(
            <div className="directory-menu">
    {/* destructurin items to map n returning each card */}
                {
                    this.state.sections.map(({ title, imageUrl, id, size }) => (
                        <MenuItem title= {title}
                                  imageUrl = {imageUrl}
                                  key = { id }
                                  size ={size}
                        />
                    )
                    ) 
                }
            </div>
            
        );
    }
    
}

export default Directory;